import {
  getTransportCompanyAndRouteParams,
  getTransportIdParams,
} from '@/app/components/hotel-detail/common/tracking.ts';

export const SUMMARY_DETAILS_SHOWN = 'SUMMARY_DETAILS_SHOWN';
export const SUMMARY_DETAILS_SHOWN_VERSION = '1.1';

export type SummaryDetailsShownPayload = {
  actionId: string;
  cartShoppingPrice: number;
  flightShoppingPrice: number;
  hotelShoppingPrice: number;
  inboundAirlineId: string;
  inboundFlightId: string;
  inboundRouteId: string;
  internalHotelId: number;
  mealPlanClass: string;
  optionIndex: number;
  outboundAirlineId: string;
  outboundFlightId: string;
  outboundRouteId: string;
  productDetailKey: string;
  providerId: string;
  roomId: string;
  searchId: string;
};

export type SummaryDetailsShownParams = {
  searchId: string;
  internalHotelId: number;
  productDetailKey: string;
  selectedRoom: RoomType;
  selectedMealPlan: MealPlanType;
  actionId: string;
  transport: TransportsType | undefined;
};

export const createSummaryDetailsShownPayload = ({
  searchId,
  internalHotelId,
  productDetailKey,
  selectedRoom,
  selectedMealPlan,
  actionId,
  transport,
}: SummaryDetailsShownParams): SummaryDetailsShownPayload => ({
  searchId,
  internalHotelId,
  roomId: selectedRoom.roomId,
  providerId: selectedMealPlan.supplier?.id?.toString(),
  productDetailKey,
  mealPlanClass: selectedMealPlan.boardClass,
  optionIndex: selectedMealPlan.index,
  actionId,
  cartShoppingPrice: selectedMealPlan.finalPrice,
  flightShoppingPrice: 0,
  hotelShoppingPrice: 0,
  ...getTransportCompanyAndRouteParams(transport),
  ...getTransportIdParams(transport),
});
